if (!customElements.get('product-accordion')) {
  customElements.define(
    'product-accordion',
    class ProductAccordion extends HTMLElement {
      constructor() {
        super();
        this.buttons = this.querySelectorAll('.accordion-button');
        this.init();
      }

      init() {
        this.buttons.forEach(button => {
          button.addEventListener('click', () => this.toggleSection(button));
        });
      }

      toggleSection(button) {
        const content = button.nextElementSibling;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        
        // Close all sections
        this.buttons.forEach(btn => {
          btn.setAttribute('aria-expanded', 'false');
          btn.nextElementSibling.classList.remove('active');
        });
        
        // Open clicked section if it was closed
        if (!isExpanded) {
          button.setAttribute('aria-expanded', 'true');
          content.classList.add('active');
        }
      }
    }
  );
}